export default __webpack_public_path__ + "static/media/pared-imagen.46e0f33c.png";